<template>
  <CourseEdit v-if="type === 'course'" />
  <ModuleEdit v-else-if="type === 'module'" />
  <MeetingEdit v-else-if="type === 'meeting'" />
  <FileEdit v-else-if="type === 'file'" />
  <VideoEdit v-else-if="type === 'video'" />
  <LessonEdit v-else-if="type === 'lesson'" />
</template>

<script>
import CourseEdit from '@/components/manage/courses/right-panel/CourseEdit.vue';
import ModuleEdit from '@/components/manage/courses/right-panel/ModuleEdit.vue';
import MeetingEdit from '@/components/manage/courses/right-panel/MeetingEdit.vue';
import FileEdit from '@/components/manage/courses/right-panel/FileEdit.vue';
import VideoEdit from '@/components/manage/courses/right-panel/VideoEdit.vue';
import LessonEdit from '@/components/manage/courses/right-panel/LessonEdit.vue';
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('courses');

export default {
  components: {
    CourseEdit,
    ModuleEdit,
    MeetingEdit,
    FileEdit,
    VideoEdit,
    LessonEdit
  },
  data: function() {
    return {
      right: true
    };
  },
  computed: mapState({
    type: state => state.activeCourseEditTree.activeElement && state.activeCourseEditTree.activeElement.type
  })
};
</script>
